export default class QuestionModel {
    constructor(module, type, view, input, range, template, difficulty) {
        this._module = module;
        this._type = type;
        this._view = view;
        this._input = input;
        this._range = range;
        this._template = template;

        this.difficulty = difficulty;

        this.part = 0;
        this.values = [];
        this.options = [];

        this.useWords = false;//globally disable

        this.operands = [];
    }

    get module() {
        return this._module;
    }

    get type() {
        return this._type;
    }

    get view() {
        return this._view;
    }

    get input() {
        return this._input;
    }

    get range() {
        return this._range;
    }

    get template() {
        return this._template;
    }

    get answer() {
        if (Array.isArray(this.part)) {
            const arr = [];
            for (let i = 0; i < this.part.length; ++i)
                arr.push(this.values[this.part[i]]);
            return arr;
        }
        return this.values[this.part];
    }

    get result() {
        return this.values[this.values.length - 1];
    }
}

QuestionModel.TYPE_ADDITION                 = "addition";
QuestionModel.TYPE_SUBTRACTION              = "subtraction";
QuestionModel.TYPE_MULTIPLICATION           = "multiplication";
QuestionModel.TYPE_DIVISION                 = "division";
QuestionModel.TYPE_DIVISION_FRACTION        = "division_fraction";
QuestionModel.TYPE_MULTIPLICATION_FRACTION  = "multiplication_fraction";
QuestionModel.TYPE_MIXED_ARITHMETIC         = "mixed_arithmetic";

QuestionModel.TYPE_TIMES_TABLE              = "times_table";

QuestionModel.TYPE_MIXED                    = "mixed";

QuestionModel.TYPE_BOOLEAN                  = "boolean";

QuestionModel.TYPE_SORT_INTEGER             = "integer";
QuestionModel.TYPE_SORT_FRACTION            = "fraction";
QuestionModel.TYPE_SORT_DECIMAL             = "decimal";

QuestionModel.TYPE_SQUARE                   = "square";

QuestionModel.TYPE_FACES                    = "faces";
QuestionModel.TYPE_RATIOS                   = "ratios";
QuestionModel.TYPE_ANGLES                   = "angles";
QuestionModel.TYPE_SIDES                    = "sides";

QuestionModel.TYPE_COMPARISON               = "comparison";
QuestionModel.TYPE_COMPARISON_FRACTION      = "comparison_fraction";
QuestionModel.TYPE_VALUE                    = "value";
QuestionModel.TYPE_COMPOSE                  = "compose";
QuestionModel.TYPE_ROUND                    = "round";

QuestionModel.TYPE_PERIMETER                = "perimeter";
QuestionModel.TYPE_AREA_TRIANGLE            = "area_triangle";
QuestionModel.TYPE_AREA_PARALLELOGRAM       = "area_parallelogram";
QuestionModel.TYPE_AREA_CIRCLE              = "area_circle";
QuestionModel.TYPE_DIAMETER                 = "diameter";
QuestionModel.TYPE_RADIUS                   = "radius";
QuestionModel.TYPE_VOLUME                   = "volume";
QuestionModel.TYPE_MISSING_ANGLE            = "missing_angle";
QuestionModel.TYPE_FIXED_TRIANGLE           = "fixed_triangle";

QuestionModel.TYPE_COVERSION_X_IN_Y         = "conversion_x_in_y";
QuestionModel.TYPE_COVERSION_SUBTRACTION    = "conversion_subtraction";
QuestionModel.TYPE_COVERSION_ADDITION       = "conversion_addition";
QuestionModel.TYPE_COVERSION_PERCENT_OF_X   = "conversion_percent_of_x";
QuestionModel.TYPE_COVERSION_MULTIPLICATION = "conversion_multiplication";
QuestionModel.TYPE_COVERSION_EQUIVALENT     = "conversion_equivalent";
QuestionModel.TYPE_COVERSION_SORT           = "conversion_sort";
QuestionModel.TYPE_LIQUID_MEASUREMENT       = "liquid_measurement";

QuestionModel.TYPE_TIME_DIFFERENCE          = "time_difference";
QuestionModel.TYPE_TIME_CONVERSION          = "time_conversion";

QuestionModel.TYPE_RATIO_SIMPLE             = "simple";
QuestionModel.TYPE_RATIO_SIMPLE_TRIPLE      = "simple_triple";
QuestionModel.TYPE_RATIO_PERCENT            = "percent";
QuestionModel.TYPE_RATIO_FIND_RAT           = "find_ratio";
QuestionModel.TYPE_RATIO_FIND_VAL           = "find_value";
QuestionModel.TYPE_RATIO_SIMPLIFY           = "simplify_ratio";

QuestionModel.TYPE_STATS_VEN                = "ven";
QuestionModel.TYPE_STATS_BAR                = "bar";
QuestionModel.TYPE_STATS_TALLY              = "tally";
QuestionModel.TYPE_STATS_LINE               = "line";
QuestionModel.TYPE_STATS_SIMPLE_MEAN        = "simple_mean";
QuestionModel.TYPE_STATS_MOST_OFTEN         = "most_often";
QuestionModel.TYPE_STATS_MIDDLE             = "middle";

QuestionModel.TYPE_FIND_REST                = "find_rest";
QuestionModel.TYPE_DOUBLE_UNKNOWN           = "double_unknown";

QuestionModel.TYPE_SHAPE_SIDES_EQUAL_FOUR       = "sides_four";
QuestionModel.TYPE_SHAPE_SIDES_UNDER_FOUR       = "sides_under_four";
QuestionModel.TYPE_SHAPE_PARALLEL_LINES         = "parallel_lines";
QuestionModel.TYPE_SHAPE_PERPENDICULAR_LINES    = "perpendicular_lines";
QuestionModel.TYPE_SHAPE_VISUAL_RIGHT_ANGLE     = "visual_right_angles";
QuestionModel.TYPE_SHAPE_VISUAL_ISOSCELES       = "visual_isosceles";
QuestionModel.TYPE_SHAPE_ODD_ONE_OUT            = "odd_one_out";
QuestionModel.TYPE_SHAPE_SYMMETRY               = "symmetry";
QuestionModel.TYPE_SHAPE_ANGLE_TYPE             = "angle_type";
QuestionModel.TYPE_SHAPE_SYMMETRY_LINES         = "symmetry_lines";
QuestionModel.TYPE_SHAPE_VERTICES               = "vertices";
QuestionModel.TYPE_SHAPE_ROTATED_SHAPE          = "rotated_shape";